module.exports = __webpack_public_path__ + "media/images/pc/accessories/dress/dress_02-5e43f57b4b36c58e958654b418a35927.jpg";